import { investmentByID, investmentCreate, investmentDestroy, investmentList, investmentUpdate } from '@/services/ventures/investments.service'

export default {
	namespaced: true,
	state: {
		investmentList: { meta: { pagination: { total: 0 } } },
		investment: {},
		investmentStatus: 'pending',
		investmentSaveStatus: 'init',
		investmentDeleteStatus: 'init',
	},
	getters: {
		getInvestmentList: s => s.investmentList,
		getInvestment: s => s.investment,
		getInvestmentStatus: s => s.investmentStatus,
		getInvestmentSaveStatus: s => s.investmentSaveStatus,
		getInvestmentDeleteStatus: s => s.investmentDeleteStatus,
	},
	mutations: {
		INVESTMENT_LIST(state, value) { state.investmentList = value },
		SET_INVESTMENT(state, value) { state.investment = value },
		INVESTMENT_STATUS(state, value) { state.investmentStatus = value },
		INVESTMENT_SAVE_STATUS(state, value) { state.investmentSaveStatus = value },
		INVESTMENT_DELETE_STATUS(state, value) { state.investmentDeleteStatus = value },
	},
	actions: {
		async fetchInvestmentList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('INVESTMENT_STATUS', 'pending')
			commit('INVESTMENT_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await investmentList(params)
				commit('INVESTMENT_STATUS', 'init')
				commit('INVESTMENT_LIST', data)
				return data
			} catch (error) {
				commit('INVESTMENT_STATUS', 'init')
				throw error
			}
		},
		async saveInvestment({ commit }, params) {
			commit('INVESTMENT_SAVE_STATUS', 'pending')
			try {
				const { data } = await investmentCreate(params)
				commit('INVESTMENT_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INVESTMENT_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateInvestment({ commit }, params) {
			commit('INVESTMENT_SAVE_STATUS', 'pending')
			try {
				const { data } = await investmentUpdate(params)
				commit('INVESTMENT_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INVESTMENT_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteInvestmentByID({ commit }, params) {
			commit('INVESTMENT_DELETE_STATUS', 'pending')
			try {
				const { data } = await investmentDestroy(params)
				commit('INVESTMENT_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INVESTMENT_DELETE_STATUS', 'error')
				return error
			}
		},
	},
}
